module.exports = __webpack_public_path__ + "images/bannerDE-fa5f148d1de63aaa8202548e15e9e023.jpg";